declare var window: any;

export const noticeError = (error: any) => {
  if (window.newrelic) {
    window.newrelic.noticeError(error);
  }
};
